import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/AuthProvider";

export const Route = createFileRoute("/")({
  component: RoleRedirect,
});

function RoleRedirect() {
  const { user, effectiveUser, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user || !effectiveUser) {
      navigate({ to: "/login" });
      return;
    }
    // Route by the effective role so an admin impersonating a rep lands on the
    // rep's dashboard rather than being snapped back to /admin.
    if (effectiveUser.role === "admin") navigate({ to: "/admin" });
    else if (effectiveUser.role === "finance") navigate({ to: "/finance" });
    else navigate({ to: "/dashboard" });
  }, [user, effectiveUser, loading, navigate]);

  return (
    <div className="container">
      <p className="lede" style={{ textAlign: "center", marginTop: 80 }}>
        Loading your workspace…
      </p>
    </div>
  );
}
